export default __webpack_public_path__ + "2282d42e46fadf9be816419942d8da7b.png";